import { useMemo } from 'react';

import useSWR from 'swr';

import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import { useCurrentProjectId } from '@adsk/alloy-provider';

import { getBaseUrl } from '../helpers/consts';

function usePermission(productAllowed = false) {
  const projectId = useCurrentProjectId();
  const url = useMemo(() => {
    const baseUrl = getBaseUrl();
    return `${baseUrl}/v1/projects/${projectId}/permissions/current`;
  }, [projectId]);

  const { data } = useSWR(productAllowed ? url : null, fetchWithToken, {
    shouldRetryOnError: false,
    revalidateOnMount: true,
    revalidateOnFocus: false,
  });

  return {
    permission: data,
  };
}
export default usePermission;
